export const LegalConsentOptions = {
  NONE: 'NONE',
  IMPLICIT_CONSENT: 'IMPLICIT_CONSENT',
  SEPERATE_CONSENT: 'SEPERATE_CONSENT',
  LEGITIMATE_INTEREST: 'LEGITIMATE_INTEREST'
};
export const LegalConsentOptionsCamelCase = Object.freeze({
  [LegalConsentOptions.NONE]: 'none',
  [LegalConsentOptions.IMPLICIT_CONSENT]: 'implicitConsent',
  [LegalConsentOptions.SEPERATE_CONSENT]: 'seperateConsent',
  [LegalConsentOptions.LEGITIMATE_INTEREST]: 'legitimateInterest'
});
export default LegalConsentOptions;